export const ParticipantType = {
	Realizator: "Realizator",
	ContractTipster: "ContractTipster",
	ClientTipster: "ClientTipster",
	InvitedSpecialist: "InvitedSpecialist",
} as const;

export type ParticipantTypeValue =
	(typeof ParticipantType)[keyof typeof ParticipantType];

export type ContractMeta = {
	division?: string;
	category?: string;
	product?: string;
	partner?: string;
	client?: string;
};

export type ConsultantOption = {
	consultantId: string;
	fullName: string;
	position?: string | null;
	division?: string | null;
};

export const MAX_NON_REALIZATOR_PARTICIPANTS = 2;
